import React, { useMemo } from 'react';
import styles from '../Styles/DiagnosticBPage.module.css';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { calcularPorcentajes } from '../../../utilities/calculateFormB';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
);

function ChartRadar({ realDataTimeForm, setValue }) {
  const chartRef = React.useRef();

  const stateData = useMemo(() => {
    const { resultados } = calcularPorcentajes(realDataTimeForm);
    // Filtra las secciones que no quieres incluir
    const resultadosFiltrados = Object.entries(resultados).reduce(
      (acc, [key, value]) => {
        if (key !== 'sec1' && key !== 'sec2') {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
    const porcentajes = Object.values(resultadosFiltrados).map(
      (sec) => sec.porcentaje,
    );
    const keyToTitleMapping = {
      sec3: 'Estrategia digital y empresarial',
      sec4: 'Experiencia de cliente',
      sec5: 'Cultura innovadora y liderazgo',
      sec6: 'Estado legal en entornos digitales y empresariales',
      sec7: 'Nivel tecnológico y de automatización',
      sec8: 'Gestión del riesgo',
    };

    const labels = Object.keys(resultadosFiltrados).map(
      (key) => keyToTitleMapping[key],
    );

    return { porcentajes, labels };
  }, [realDataTimeForm]);

  const data = {
    labels: stateData.labels,
    datasets: [
      {
        label: '',
        data: stateData.porcentajes,
        backgroundColor: '#c7f2418c',
        borderColor: '#c7f241',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    animation: {
      // Función que se llama automáticamente cuando la animación del gráfico se completa.
      onComplete: function () {
        if (chartRef.current && chartRef.current.canvas) {
          const base64Image = chartRef.current.canvas.toDataURL('image/jpg');
          setValue('chatRadarImg', base64Image);
        }
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        min: 0, // Mínimo del rango
        max: 100, // Máximo del rango
        ticks: {
          stepSize: 20, // Puedes ajustar esto según lo que necesites
        },
      },
    },
  };

  return (
    <Radar
      className={styles.charRadar}
      ref={chartRef}
      data={data}
      options={options}
    />
  );
}
export default ChartRadar;
